// extracted by mini-css-extract-plugin
export default {"footer":"AppFooter_footer__s7rIc","hover-link":"AppFooter_hover-link__9oqHF","heart":"AppFooter_heart__6KzHx"};